import { Backdrop, CircularProgress, Typography, Grid } from '@mui/material'
import React from 'react'

const BackdropSpinner = () => {
  return (
    <Backdrop open style={{ zIndex: 9999999 }}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        direction="column"
        spacing={2}
      >
        <Grid item>
          <CircularProgress color="primary" />
        </Grid>

        <Grid item>
          <Typography variant="h6" style={{ color: '#eee' }}>
            Vui lòng chờ trong giây lát...
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="h6" style={{ color: '#eee' }}>
            Please wait a moment...
          </Typography>
        </Grid>
      </Grid>
    </Backdrop>
  );
}

export default BackdropSpinner
